import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectReportsByAvailability } from 'store/seatingChart/selectors';
import { Button } from '../ui/button';

interface ChooseSeatsButtonProps {
  handleOpenChart: () => void;
  seatsCategoryKey: string;
}

const ChooseSeatsButton: React.FC<ChooseSeatsButtonProps> = ({
  handleOpenChart,
  seatsCategoryKey,
}) => {
  const { t } = useTranslation();
  const reportsByAvailability = useSelector(selectReportsByAvailability);
  const report = reportsByAvailability?.find(
    report => report.categoryKey === seatsCategoryKey,
  );

  // we don't want to display anything until reports are fetched or if the category is not available
  if (!report || !report.available) {
    return null;
  }

  return (
    <div className="md:hidden">
      <Button onClick={handleOpenChart}>{t('ticketSale.chooseSeats')}</Button>
    </div>
  );
};

export default ChooseSeatsButton;
